import * as Types from '../../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type DataObjectThumbnailJobStatusQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type DataObjectThumbnailJobStatusQuery = { __typename: 'Query', dataObject: { __typename: 'DataObject', id: string, thumbnailProcessingJob?: { __typename: 'Job', id: string, state: Types.JobState } | null } };

export const DataObjectThumbnailJobStatusDocument = gql`
    query DataObjectThumbnailJobStatus($id: ID!) {
  dataObject(id: $id) {
    id
    thumbnailProcessingJob {
      id
      state
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class DataObjectThumbnailJobStatusGQL extends Apollo.Query<DataObjectThumbnailJobStatusQuery, DataObjectThumbnailJobStatusQueryVariables> {
    override document = DataObjectThumbnailJobStatusDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }